import * as React from 'react';
import * as _ from 'lodash';
import * as styles from '../../help/help.module.scss';
import TransferList from '../../common/transfer-list';
import SecondaryButton from '../../common/secondary-button';
import Client from '../../../models/client';
import useHelp from '../../../hooks/useHelp';
import useHelpDocuments from '../../../hooks/useHelpDocuments';

interface Props {
  initialMappedClients: Client[];
  initialUnmappedClients: Client[];
  documentId: number;
  closeMapModal: () => void;
}

const GlobalMapModalContent = ({ initialMappedClients, initialUnmappedClients, documentId, closeMapModal }: Props) => {
  const [unmappedClients, setUnmappedClients] = React.useState<Client[]>(initialUnmappedClients);
  const [mappedClients, setMappedClients] = React.useState<Client[]>(initialMappedClients);
  const { fetchGlobalHelpDocuments } = useHelpDocuments();
  const { mapGlobalDocument } = useHelp();

  const saveHandler = () => {
    const clientList = mappedClients.map(client => client.clientId);
    mapGlobalDocument(clientList, documentId).then(() => fetchGlobalHelpDocuments(true));
    closeMapModal();
  };

  return (
    <React.Fragment>
      <form className={styles.userForm}>
        <TransferList
          idField="clientId"
          labelField="name"
          left={unmappedClients}
          right={mappedClients}
          setLeft={setUnmappedClients}
          setRight={setMappedClients}
          leftLabel="Unmapped Clients"
          rightLabel="Mapped Clients"
          setFieldValue={() => {}}
          setField=""
          height="460px"
        />
      </form>
      <div className={styles.modalActionFooter}>
        <SecondaryButton
          text="Save"
          title="Save"
          deactive={_.isEqual(mappedClients, initialMappedClients)}
          handleClick={saveHandler}
        />
      </div>
    </React.Fragment>
  );
};

export default GlobalMapModalContent;
